export default {
  locale: "es",
  messages: {
    name: "Ordenante",
    nif: "Nif",
    date: "Fecha",
    concept: "Observaciones",
    amount: "Importe",
    society: "Sociedad",
    division: "División",
    account: "Nº de cuenta",
    empty: " ",
    sapCode: "Cód. SAP",
    userRule: "Usuario / Regla",
    businessLine: "Línea de negocio",
    referenceNumber: "Nº Referencia",
    expirationDate: "Fecha VCTO",
    accountingKey: "Clave contable",
    recArea: "Área de reclamación",
    auto: "Validar",
    archive: "Archivo",
    updatedDate: "Fecha modificación",
    type: "Tipo",
    ceco: "CECO",
    origen: "Origen",
    sapStatus: "Estado SAP",
    auxAccountNumber: "Cuenta auxiliar"
  }
};
